
    const directoryData = {
  "categories": [
    {
      "id": "vcm",
      "display": "Virtual Cell Models",
      "descr": "A virtual cell model is a model that predicts the systemic responses of individual cells to perturbations such as gene knock-outs or therapeutic interventions under varying cell types and genetics.",
      "publish": true,
      "children": [
        {
          "id": "vcm_incumbent",
          "display": "Established Incumbents",
          "descr": "These companies have both a significant amount of VC funding and a roster of large- and medium-sized pharma partners."
        },
        {
          "id": "vcm_rising",
          "display": "Rising Stars",
          "descr": "These companies were all founded since 2022 but have raised significant capital and signed partnerships with medium to large pharma companies."
        },
        {
          "id": "vcm_academic",
          "display": "Academics to Watch",
          "descr": "These companies were founded by either current faculty or recent graduates of academic institutes. And while they haven't completely broken into the pharma market yet, they're building interesting new technology and could be the rising stars of the next few years."
        },
        {
          "id": "vcm_tech",
          "display": "Tech Founders to Watch",
          "descr": "These early-stage companies were launched by founders with backgrounds that lean more towards tech than biotech. The jury is still out one whether this outsider perspective will be able to disrupt biopharma in the same way that it has distupted other industries."
        }
      ],
      "longDescription": "A virtual cell model is a model that predicts the systemic responses of individual cells to perturbations such as gene knock-outs or therapeutic interventions under varying cell types and genetics.\n\nTrained on a combination of observed/experimental data and curated knowledge, these models learn how the direct interactions between components of a cell cascade into the long-range, indirect impacts that determine phenotypic responses.\n\nAs the link between the individual molecular interactions and the organ-, patient- and population-level responses that drive clinical outcomes, virtual cell models are evolving into the middle layer in an emerging multi-scale modeling \"stack.\""
    },
    {
      "id": "sdms",
      "display": "Scientific Data Management Systems",
      "descr": "Tools and systems for organizing, analyzing and visualizing experimental data and metadata.",
      "publish": true,
      "children": [
        {
          "id": "sdms_int",
          "display": "Data Integration Platforms",
          "descr": "Each of these platforms acts as a central hub that collects and integrates data from multiple sources. They are general purpose, with the goal of supporting as many different data types and use cases as possible."
        },
        {
          "id": "sdms_pipeline",
          "display": "Screening and Pipeline Tracking",
          "descr": "These tools also collect and organize data from different sources, but with a narrower, purpose-built focus on enabling decision making and tracking drug candidates as they move through the pipeline."
        },
        {
          "id": "sdms_catalog",
          "display": "Data Organization and Cataloging Tools",
          "descr": "These tools address similar pain points to the Data Integration Platforms, helping teams integrate and organize data from a variety of sources, but take a more light-weight approach rather than providing an all-encompassing platform."
        },
        {
          "id": "sdms_ngs",
          "display": "Multi-omic/NGS Platforms",
          "descr": "These systems are also similar to the Data Integration Platforms category, but with specialized functionality for managing and curating multi-omic/NGS data."
        },
        {
          "id": "sdms_vis",
          "display": "General Analysis and Visualization",
          "descr": "These are modality-agnostic tools for visualizing and analyzing data. They range from all-encompassing platforms to more light-weight systems."
        }
      ],
      "longDescription": "This is a heterogeneous category with each subcategory, or even each tool, addressing different pain points or using a different approach. All are focused in one way or another on handling data outside the lab, whether that data comes from an internal lab or other sources.\n\nThe subcategories are also a bit fuzzy. Each tool has been assigned to a subcategory based on its primary function, but may have secondary functions that fit within other subcategories.\n"
    }
  ],
  "companies": [
    {
      "id": "ai_vivo",
      "display": "AI VIVO",
      "website": "https://aivivo.co/",
      "linkedin": "",
      "icon": "ai_vivo.jpeg",
      "categories": [
        "vcm",
        "vcm_academic"
      ],
      "description": "AI VIVO was spun out of the Wellcome Sanger Institure at Cambridge University by its founder and CEO, Peyman Gifani, in 2017. It has mostly worked with academic and government clients so far, but markets itself to biotech/pharma as well. Their model primarily leverages in vitro transcriptomic data.",
      "publish": true
    },
    {
      "id": "aita_bio",
      "display": "Aitia",
      "website": "https://www.aitiabio.com/",
      "linkedin": "",
      "icon": "aita_bio.jpg",
      "categories": [
        "vcm",
        "vcm_incumbent"
      ],
      "description": "Technically, Aitia is the oldest of the virtual cell model companies by over 15 years, founded in 2000 as Gene Network Sciences by two Cornell Physicists. However, it only pivoted from a general purpose analysis platform to a virtual cell provider when it rebranded as Aitia in 2023.\n\nAitia has publicly announced partnerships are with Servier, Orion and Merck, for projects including target discovery and patient stratification for oncology and neurodegenerative disorders Their models are trained entirely on data from patient samples, incorporating a wide array of assays including whole-genome sequencing, RNA-seq, proteomics, metabolomics and epigenomics, as well as patient records and outcomes.\n\nLike the other established incumbents, Aitia offers a white-glove engagement model. However, their engagements often resemble traditional drug program partnerships more than technology partnerships.",
      "publish": true
    },
    {
      "id": "bio_lizard",
      "display": "BioLizard",
      "website": "https://lizard.bio/",
      "linkedin": "",
      "icon": "bio_lizard.png",
      "categories": [
        "sdms",
        "sdms_vis"
      ],
      "publish": true,
      "description": "BioLizard's BioVerse platform (BioReflect, ProBiome, BioMx) supports literature synthesis, microbiome analysis, and multi-omics visualization. BioLizard pairs software with hands-on expert services for teams who want a tailored analytical partner in addition to an off-the-shelf product."
    },
    {
      "id": "cdd",
      "display": "CDD Vault",
      "website": "https://www.collaborativedrug.com/",
      "linkedin": "",
      "icon": "cdd.jpeg",
      "categories": [
        "sdms",
        "sdms_pipeline"
      ],
      "publish": true,
      "description": "CDD Vault combines drug candidate registration, dose/concentration response curve analysis, and screening-data management behind an intuitive interface. It is designed to enable data-sharing across internal teams, CROs, and partners without heavy IT overhead."
    },
    {
      "id": "cell_bauhaus",
      "display": "Cell Bauhaus",
      "website": "https://cellbauhaus.com/",
      "linkedin": "",
      "icon": "cell_bauhaus.jpeg",
      "categories": [
        "vcm",
        "bioprocessing",
        "vcm_academic"
      ],
      "description": "Cell Bauhaus was founded in 2023 by two faculty members at the University of Melbourne. They're unique in that they're initially focussing solely on modeling microbial cells for biomanufacturing. This allows them to build a much more detailed model of much simpler cells, using a relatively rare model architecture - stochastic particle simulation. But they plan to expand this approach to eventually be able to model human cells at an unprecedented level of detail.",
      "publish": true
    },
    {
      "id": "cellular_intel",
      "display": "Cellular Intelligence",
      "website": "https://www.cellularintelligence.com/",
      "linkedin": "",
      "icon": "cellular_intel.png",
      "categories": [
        "vcm",
        "vcm_rising"
      ],
      "publish": true,
      "description": "Cellular Intelligence was founded in 2023 as Somite AI, by a serial entrepreneur and a team of AI and systems biology faculty from MIT, Harvard Medical School, University of Washington and University of Pennsylvania, before rebranding with its current name in 2026.\n\nIt has raised a reported $62M in funding, mostly from a $47M Series A in 2025. They're lighter on partnerships, with only one publicly announced deal with OmniaBio to optimize their biomanufacturing. However, they also have an internal pipeline that includes drug candidates for Duchenne Muscular Dystrophy (DMD) and Type-1 diabetes.\n\nTheir model is primarily trained on data from human pluripotent stem cells (hPSCs) and is designed to track the temporal development of these cells. While their model is based on a transformer rather than a mechanistic/hybrid model, they use \"20 fundamental molecular signaling pathways\" to interpret the model's predictions."
    },
    {
      "id": "converge",
      "display": "Converge Bio",
      "website": "https://converge-bio.com",
      "linkedin": "",
      "icon": "converge.jpeg",
      "categories": [
        "protein_design_triage",
        "vcm",
        "bioprocessing",
        "vcm_rising"
      ],
      "description": "Converge Bio was founded in 2024 by a trio in Tel Aviv with industry experience in Machine Learning and Bioinformatics.\n\nThey've raised $30M in venture capital, most of which came from their $25M Series A in 2026. They've stated publicly that they're running more than 40 projects with pharma and biotech partners, though they haven't named any of these partners publicly. Unlike the incumbents and the other rising stars, Converge offers a SaaS platform with a low-code interface for scientists, rather than a white-glove service.\n\nTheir model is trained on a combination of patient samples, animal samples and public genomics datasets. In particular, they have collected over 5,000 patient samples across 40 clinical indications. They also have a large volume of biomanufacturing data that includes microbial samples.",
      "publish": true
    },
    {
      "id": "cypher",
      "display": "Cypher",
      "website": "https://cypherbio.ai/",
      "linkedin": "",
      "icon": "cypher.jpeg",
      "categories": [
        "eln",
        "sdms",
        "sdms_vis"
      ],
      "publish": true,
      "description": "Cypher enables scientists to build custom, no-code tools for data analysis, visualization, and protocol automation, minimizing time spent on repetitive analysis tasks. It is designed to be fast and easy to use, replacing the need for coding expertise or hours of manual plotting with a few clicks and prompts."
    },
    {
      "id": "cytoreason",
      "display": "CytoReason",
      "website": "https://cytoreason.com",
      "linkedin": "",
      "icon": "cytoreason.jpeg",
      "categories": [
        "vcm",
        "vcm_incumbent"
      ],
      "description": "CytoReason was founded in 2016 around the research of a professor at the Technion (Israel Institute of Technology) with a co-founding CEO from private equity. It has raised the most funding of the companies in this report, at total of $120M, with $80M coming from a Series B in 2024.\n\nIt has publicly announced partnerships with Pfizer, Sanofi, GSK and Roche, as well as with a number of mid-sized pharma companies. These cover a wide range of therapeutic areas, though the largest focus seems to be immunology and immuno-oncology.\n\nCytoReason puts a large emphasis on patient data, though with a narrower focus on transcriptomics and proteomics. However, they also incorporate public genomics datasets, cell line assays and curated knowledge from published literature.",
      "publish": true
    },
    {
      "id": "cytocast",
      "display": "Cytocast",
      "website": "https://cytocast.com",
      "linkedin": "",
      "icon": "cytocast.jpeg",
      "categories": [
        "vcm",
        "vcm_academic"
      ],
      "description": "Cytocast was spun out of P\u00e1zm\u00e1ny P\u00e9ter Catholic University in Budapest in 2019 - a collaboration between a computational/systems biologist and a high-performance computing specialist. Like Cell Bauhaus, they also offer a stochastic model, but apply it to simulating human cells for drug discovery. In late 2025, they announced a shift in their product strategy aimed at transitioning from a research-heavy, academic operation to a more product-focused company.",
      "publish": true
    },
    {
      "id": "data_chaperone",
      "display": "DataChaperone",
      "website": "https://datachaperone.nl/",
      "linkedin": "",
      "icon": "data_chaperone.jpeg",
      "categories": [
        "sdms",
        "sdms_vis"
      ],
      "publish": true,
      "description": "DataChaperone automates repetitive analysis workflows such as qPCR analysis for CROs, CDMOs, and biotech teams, turning manual steps into few-click, audit-ready results. It allows teams to work incrementally, automating one workflow at a time, with full traceability and AI-assisted decision support layered in over time."
    },
    {
      "id": "datajoint",
      "display": "DataJoint",
      "website": "https://www.datajoint.com/",
      "linkedin": "",
      "icon": "datajoint.jpeg",
      "categories": [
        "sdms",
        "sdms_catalog"
      ],
      "publish": true,
      "description": "Originally built for neuroscience research, DataJoint is a computational database that codifies experiments, pipelines, and results as structured, reproducible scientific data with full lineage."
    },
    {
      "id": "datagrok",
      "display": "Datagrok",
      "website": "https://datagrok.ai/",
      "linkedin": "",
      "icon": "datagrok.png",
      "categories": [
        "sdms",
        "sdms_vis"
      ],
      "publish": true,
      "description": "DataGrok provides specialized, in-memory analytics and visualization, treating molecules, peptides, and proteins as core concepts rather than add-ons. It is blazingly fast and native to the browser, providing a modern alternative to tools like Spotfire."
    },
    {
      "id": "deep_life",
      "display": "DeepLife",
      "website": "https://www.deeplife.co/",
      "linkedin": "",
      "icon": "deep_life.jpeg",
      "categories": [
        "vcm",
        "vcm_tech"
      ],
      "description": "DeepLife was founded in 2019 by a hardware engineer and an AI researcher with expertise in genetics. So far, their projects have veered more towards food production and consumer health products, including a collaboration with Beiersdorf. However, they're also part of a collaboration with the French national institute of public health to address pediatric cancer.",
      "publish": true
    },
    {
      "id": "enpicom",
      "display": "ENPICOM",
      "website": "https://enpicom.com/",
      "linkedin": "",
      "icon": "enpicom.jpeg",
      "categories": [
        "multi_omics",
        "sdms",
        "sdms_ngs"
      ],
      "publish": true,
      "description": "ENPICOM's IGX Platform is focused on managing and analyzing immune-repertoire sequencing data (antibody/TCR discovery), integrating assay results, developability predictions, and sequence clustering."
    },
    {
      "id": "elucidata",
      "display": "Elucidata",
      "website": "https://www.elucidata.io/",
      "linkedin": "",
      "icon": "elucidata.jpeg",
      "categories": [
        "sdms",
        "sdms_ngs"
      ],
      "publish": true,
      "description": "Elucidata automatically curates and harmonizes hundreds of thousands of public and proprietary multi-omics datasets into a unified, ML-ready data model. It is built for scale and provides an LLM-powered harmonization engine that makes historical and third-party data instantly analysis-ready."
    },
    {
      "id": "genbioai",
      "display": "GenBioAI",
      "website": "https://genbio.ai/",
      "linkedin": "",
      "icon": "genbioai.jpeg",
      "categories": [
        "vcm",
        "vcm_tech"
      ],
      "description": "The four cofounders of GenBioAi were academics, including two Carnegie Mellon professors, but only one is a biologist, with the other three from machine learning/AI. They may be the most community-focused of these companies, making their models available on the AI sharing platform HuggingFace and running an outreach campaign targeted at collaborating with other startups.",
      "publish": true
    },
    {
      "id": "genedata",
      "display": "Genedata Screener",
      "website": "https://www.genedata.com/",
      "linkedin": "",
      "icon": "genedata.jpeg",
      "categories": [
        "sdms",
        "sdms_pipeline"
      ],
      "publish": true,
      "description": "Genedata Screener is the industry-standard platform for automating and analyzing high-throughput screening data, including biochemical, cellular, biophysical and imaging data. It provides a consistent interface for moving assets through the pipeline, along with specialized tools for analyzing a wide range of assay types."
    },
    {
      "id": "genestack",
      "display": "Genestack",
      "website": "https://genestack.com/",
      "linkedin": "",
      "icon": "genestack.jpeg",
      "categories": [
        "sdms",
        "sdms_ngs"
      ],
      "publish": true,
      "description": "Genestack is a data management platform for curating and integrating NGS, omics, clinical, and biobank data. It has a long track record of working with large organizations on data integration projects."
    },
    {
      "id": "gutz",
      "display": "Gutz Analytics",
      "website": "https://gutzanalytics.com/",
      "linkedin": "",
      "icon": "gutz.jpeg",
      "categories": [
        "vcm",
        "vcm_academic"
      ],
      "description": "Gutz was founded to commercialize and scale the open source scikit-bio Python library, building off of post-doctoral research by its founder at the Flatiron Institute\u2019s Center for Computational Biology and the National Institutes of Health (NIH). The company is particularly focused on applying the model to microbiom analysis related to neurodevelopmental indications and cardiology.",
      "publish": true
    },
    {
      "id": "thinking_node",
      "display": "Infinitus Bio (formerly ThinkingNode)",
      "website": "https://www.thinkingnode.life/",
      "linkedin": "",
      "icon": "infinitus.jpeg",
      "categories": [
        "vcm",
        "vcm_tech"
      ],
      "description": "ThinkingNode was founded in 2017 by a serial entrepreneur with a background in medicine, but whose early success came from startups in financial tech and social networking. It rebranded as Infinitus in 2026. Its most prominent project so far is a collaboration with the Swiss drug maker Debiopharm that involves indication expansion and combination therapy identification.",
      "publish": true
    },
    {
      "id": "kaleidoscope",
      "display": "Kaleidoscope",
      "website": "https://www.kaleidoscope.bio/",
      "linkedin": "",
      "icon": "kaleidoscope.jpeg",
      "categories": [
        "sdms",
        "sdms_pipeline"
      ],
      "publish": true,
      "description": "Kaleidoscope centralizes program data, experiments, and decisions into live dashboards so teams can track milestones, budgets, and go/no-go decisions. While it can pull data from a range of sources and facilitate data sharing with CROs, it is primarily designed to give teams program- and portfolio-level visibility into their pipeline."
    },
    {
      "id": "lamin",
      "display": "Lamin Labs",
      "website": "https://lamin.ai",
      "linkedin": "",
      "icon": "lamin.png",
      "categories": [
        "sdms",
        "multi_omics",
        "sdms_catalog"
      ],
      "publish": true,
      "description": "An open-source, git-like data management tool for multimodal biological data (especially single-cell and spatial), giving teams lineage tracking, schema enforcement, and versioning across storage formats. It allows users to treat multiple genomics datasets as a single giant matrix while enforcing shared vocabularies/ontologies."
    },
    {
      "id": "markov",
      "display": "Markov.bio",
      "website": "https://markov.bio/",
      "linkedin": "",
      "icon": "markov.png",
      "categories": [
        "vcm",
        "vcm_tech"
      ],
      "description": "Markov Bio, which was founded in 2023, offers the least publicly available information of the companies in this report. Its website suggests a focus on helping pharma team design optimal wet lab experiments in order to reduce overall costs.",
      "publish": true
    },
    {
      "id": "noetik",
      "display": "NOETIK",
      "website": "https://www.noetik.ai/",
      "linkedin": "",
      "icon": "noetik.jpeg",
      "categories": [
        "vcm",
        "vcm_rising"
      ],
      "description": "NOETIK was founded in 2022 by the former CSO and the former Head of Oncology at Recursion, with the goal of addressing the \"translation gap\" between early discovery and the clinic and a focus on oncology.\nThey've raised a reported $54M, including a $40M Series A in 2024.\n\nThey've publicly announced a partnership with GSK to develop therapeutics for non-small cell lung cancer and colorectal cancer. They also have a partnership with Agenus to develop biomarkers for Agenus\u2019 lead clinical stage immuno-oncology combination.\n\nTheir model is trained entirely on human samples, primarily from tumors. However, they use a secondary dataset generated from in vivo mouse models to functionally validate their predictions. And they do not use curated knowledge such as cell signaling networks because the believe it introduces bias into the model.",
      "publish": true
    },
    {
      "id": "quilt",
      "display": "Quilt.bio",
      "website": "https://www.quilt.bio/",
      "linkedin": "",
      "icon": "quilt.jpeg",
      "categories": [
        "sdms",
        "sdms_catalog"
      ],
      "publish": true,
      "description": "Quilt provides both command line/code-based tools and a web-based interface for organizing data into \"packages\" that allow data scientists/computational biologists to easily coordinate analysis with bench scientists."
    },
    {
      "id": "quriegen",
      "display": "QurieGen",
      "website": "https://www.quriegen.com/",
      "linkedin": "",
      "icon": "quriegen.jpeg",
      "categories": [
        "vcm",
        "vcm_academic"
      ],
      "description": "QurieGen was spun out of Radboud University in The Netherlands in 2022 by two faculty members with expertise in physical chemistry plus one long-time investor. They've run pilot trials with companies including Janssen and Acerta Pharma, a subsidiary of AstraZeneca.",
      "publish": true
    },
    {
      "id": "reflector",
      "display": "Reflector",
      "website": "https://reflector.bio/",
      "linkedin": "",
      "icon": "reflector.jpeg",
      "categories": [
        "vcm",
        "vcm_academic"
      ],
      "description": "Reflector was founded in 2025 by two recent PhD students from the Theis lab at the Institute of Computational Biology at Helmholtz Munich and the Technical University of Munich. Their model is able to use a wide range of functional data in addition to the standard transcriptomic and proteomic data that most virtual cell models are trained on.",
      "publish": true
    },
    {
      "id": "scispot",
      "display": "SciSpot",
      "website": "https://www.scispot.com/",
      "linkedin": "",
      "icon": "scispot.jpeg",
      "categories": [
        "sdms",
        "sdms_int"
      ],
      "publish": true,
      "description": "While SciSpot offers an ELN/LIMS, it is often used to aggregate data from external ELNs or LIMS, along with data from instruments, CROs and other sources. Its goal is to provide a single no-code \"Lab Operating System\" to manage operations across the organization."
    },
    {
      "id": "scitara",
      "display": "Scitara",
      "website": "https://scitara.com/",
      "linkedin": "",
      "icon": "scitara.jpeg",
      "categories": [
        "sdms",
        "sdms_int"
      ],
      "publish": true,
      "description": "Scitara replaces brittle point-to-point connections with a no/low-code orchestration layer linking instruments, LIMS, and ELNs. It is designed to be as easy as possible to deploy, offering a large library of pre-built connectors to minimize the need for custom configuration."
    },
    {
      "id": "synthesize",
      "display": "Synthesize Bio",
      "website": "https://www.synthesize.bio/",
      "linkedin": "",
      "icon": "synthesize.jpeg",
      "categories": [
        "vcm",
        "vcm_academic"
      ],
      "description": "Synthesize was launched in 2025 by the Chief Data Officer and the Head of Translational Data Science at the Fred Hutchinson Cancer Center in Seatle. Their primary focus is generating synthetic data for conducting virtual clinical trials.",
      "publish": true
    },
    {
      "id": "tetra_science",
      "display": "TetraScience",
      "website": "https://www.tetrascience.com/",
      "linkedin": "",
      "icon": "tetra_science.jpeg",
      "categories": [
        "sdms",
        "sdms_int"
      ],
      "publish": true,
      "description": "TetraScience connects lab instruments, informatics software, and CRO/CDMO data into one harmonized, vendor-neutral platform. It focuses on transforming raw instrument output into AI-ready, GxP-compliant data at enterprise scale, integrating with a broad array of instruments and assay types. Its customers tend to be large pharma companies."
    },
    {
      "id": "turbine",
      "display": "Turbine",
      "website": "https://turbine.ai/",
      "linkedin": "",
      "icon": "turbine.jpeg",
      "categories": [
        "vcm",
        "vcm_incumbent"
      ],
      "description": "Turbine was founded in 2015 by a Hungarian trio that included a serial entrepreneur, a clinical oncologist and computer scientist turned biochemist, giving their founding team the broadest expertise of the three incumbents.\n\nThey have publicly announced partnerships with AstraZeneca, MSD and Bayer with a focus on Antibody-Drug Conjugates (ADCs) and target validation for oncology and immunology.\n\nOf the three incumbents, Turbine places the largest emphasis on in vitro data over patient samples, though they incorporate both. They're also the only incumbent that offers a lab-in-the-loop capability in which they run in vitro experiments on behalf of partners to fine tune their models.",
      "publish": true
    },
    {
      "id": "zontal",
      "display": "Zontal",
      "website": "https://zontal.io/",
      "linkedin": "",
      "icon": "zontal.jpeg",
      "categories": [
        "sdms",
        "sdms_int"
      ],
      "publish": true,
      "description": "Zontal centralizes and harmonizes data from instruments, LIMS, and ELNs into a unified, analytics-ready environment. It offers modular \"hubs\" (chemistry, imaging, methods) and specializes in decommissioning legacy systems, particularly helping large pharma companies to incorporate data from recently merged acquisitions."
    },
    {
      "id": "sci2sci",
      "display": "sci2sci (VectorCat)",
      "website": "https://www.sci2sci.com/",
      "linkedin": "",
      "icon": "sci2sci.jpeg",
      "categories": [
        "sdms",
        "sdms_catalog"
      ],
      "publish": true,
      "description": "VectorCat makes historical and current data findable and harmonized across wet lab, CRO, and computational sources. It pairs this with LLM-based agents for search and automation to make the technical aspects of data management accessible to bench scientists."
    }
  ]
}

    export default directoryData;
    